import { decode as base64url } from 'jose/dist/browser/util/base64url';
import { decoder } from 'jose/dist/browser/lib/buffer_utils';

function isTokenExpired(jwt) {
  if (typeof jwt !== 'string')
    return true;

  const payload = jwt.split('.')[1];
  const verificationRes = JSON.parse(decoder.decode(base64url(payload)));

  if (!verificationRes.exp)
    return true;

  return Date.now() > verificationRes.exp * 1000;
}

export default isTokenExpired;